// @TODO: remove tibbits code
/**
 * Ryan O'Dowd
 * 2022-12-04
 * © Copyright 2022 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import BackgroundGradient from '@components/common/BackgroundGradient';
import {
  Button as PaperButton,
} from 'react-native-paper';
import React from 'react';
import {
  View,
} from 'react-native';
import getStyles from './styles';
import globals from '@utils/globals';
import hooks from '@hooks';

const Button = (props: ButtonProps & React.ComponentProps<typeof PaperButton>) => {
  const styles = hooks.useStyles(getStyles);

  let {
    containerStyle, /* eslint-disable-line prefer-const */
    style, /* eslint-disable-line prefer-const */
    children, /* eslint-disable-line prefer-const */
    theme,
    textColor,
    ...restProps /* eslint-disable-line prefer-const */
  } = props;

  theme = theme || 'primary';

  if (['text', 'outlined'].includes(props.mode)) {
    textColor = props.theme || styles.colors.dialogText;
  } else if ([ // @TODO: should use string or styles.colors only...not both
    'white',
    'accent',
    'accentLight',
    'primaryExtraLight',
    'primaryLight',
    styles.colors.white,
    styles.colors.accent,
    styles.colors.accentLight,
    styles.colors.primaryExtraLight,
    styles.colors.primaryLight,
    styles.colors.lightGray,
  ].includes(theme)) {
    textColor = styles.colors.primaryExtraDark;
  } else if ([
    'alert',
    'primary',
    styles.colors.alert,
    styles.colors.primary,
    styles.colors.incorrect,
  ].includes(theme)) {
    textColor = styles.colors.white;
  }

  let buttonColor = styles.colors[theme] || styles.colors.primary;
  if (theme?.startsWith('#')) {
    buttonColor = theme;
  }
  return (
    <View style={[...(Array.isArray(containerStyle) ? containerStyle : [containerStyle])]}>
      <View style={styles.container}>
        {globals.appName === 'tibbits' && restProps.mode === 'contained' && !props.disabled && // @TODO: want this to be all buttons in wrinkly as well? think it looks good...
          <BackgroundGradient
            style={[styles.gradient, styles.container]}
            theme={buttonColor}// @TODO: shouldn't be hex value...should be string primary/accent/etc.
            reverse={styles.isDarkMode}
          />
        }
        <PaperButton
          style={[globals.appName === 'tibbits' && styles.container, ...(Array.isArray(style) ? style : [style]), props.disabled && styles.disabled]}
          buttonColor={['text', 'outlined'].includes(props.mode) ? null : buttonColor}
          textColor={textColor}
          labelStyle={props.isLarge && styles.largeText}
          uppercase={true}
          {...restProps}
        >
          {children}
        </PaperButton>
      </View>
    </View>
  );
};

class ButtonProps {
  containerStyle?: any;
  theme?: 'primary' | 'accent' | 'alert' | 'white' | 'primaryLight' | 'incorrect' | 'accentLight' | 'primaryDark'; // @TODO: this is also the name of a paper button prop, but that's not how it's being used
  isLarge?: boolean;
  // @TODO: disallow buttonColor, textColor (should always be theme)...at the very least, need to look at all usages of those two and update buttons accordingly
};

Button.displayName = 'Button';
export default Button;
